    <div class="modal-header">
        <h5 class="modal-title">Concludi Viaggio</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div style="margin-bottom: 10px; text-align:center;"><b >viaggio # {{travelToEnd.id}}</b></div>
        <div  class="mb-3">
            Liv carburante:
            <rating [max]="5" [(ngModel)]="travelToEnd.fuel_level" [customTemplate]="tt"></rating>

            <ng-template #tt let-i="index" let-v="value">
                <button class="btn btn-{{i < v ? 'alert' : 'default'}}">
                    {{i == 0 ? '&#48;' : ''}}
                    {{i == 1 ? '&#188;' : ''}}
                    {{i == 2 ? '&#189;' : ''}}
                    {{i == 3 ? '&#190;' : ''}}
                    {{i == 4 ? '&#49;' : ''}}
                </button>
            </ng-template>
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text" >Km</span>
            </div>
            <input type="number" min="1" max="999999" class="form-control" placeholder="Kilometri attuali"
                   [(ngModel)]="travelToEnd.end_kilometers"
                   aria-label="Kilometri attuali" aria-describedby="basic-addon1">
        </div>


        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">Data</span>
            </div>
            <input type="text"
                   class="form-control"
                   #dp="bsDatepicker"
                   style="height: auto;"
                   bsDatepicker
                   [bsConfig]="{dateInputFormat: 'D/MM/YYYY', showWeekNumbers: false}"
                   [(bsValue)]="travelToEnd.ended_at"
                   (bsValueChange)="onDateChange($event)"
                   [minDate]="minDate"
                   [maxDate]="maxDate"
                   onkeydown="return false">
            <timepicker [(ngModel)]="travelToEnd.ended_at" (ngModelChange)="onDateChange($event)" [showMeridian]="false" [min]="minDate" [max]="maxDate"></timepicker>
        </div>

        <div class="form-group">
            <label for="segnalazioni">Segnalazioni</label>
            <textarea class="form-control height250"  id="segnalazioni" [(ngModel)]="travelToEnd.reporting"
                      maxlength="250"></textarea>
        </div>

    <app-itinerario #itinerarioComp [itinerario]="itinerario" [modifications]="true"></app-itinerario>

    </div><!-- end modal body-->
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="bsModalRef.hide()">Annulla</button>
        <button type="button"
                class="btn btn-primary"
                data-dismiss="modal"
                (click)="endTravel()">
            {{ dom_elements.end_btn.is_running ? dom_elements.end_btn.txt_run : dom_elements.end_btn.txt_not_run}}
        </button>
    </div>
